module.exports = "/_next/static/images/cell_4-764f1963963db1407e2b8120a9ec69da.png";